export const en: Record<string, string> = {
  "pricing.workersFree": "Workers always free",
  "pricing.title": "Simple, transparent pricing",
  "pricing.comingSoon.title": "Coming Soon",
  "pricing.comingSoon.description": "Our pricing page is on its way! In the meantime, explore KontrataPH and find your next opportunity.",
  "pricing.comingSoon.explore": "Explore KontrataPH",
  "pricing.intro": "Free for workers. You only pay for premium business tools and protected transactions — every fee is shown before you confirm.",
  "pricing.group.workers": "For Workers & Professionals",
  "pricing.group.workersDescription": "Always free to find work. Upgrade only if you want more visibility.",
  "pricing.mostPopular": "Most popular",
  "pricing.free": "Free",
  "pricing.getStartedFree": "Get started free",
  "pricing.choosePlan": "Choose plan",
  "pricing.group.employer": "For Employers & Companies",
  "pricing.group.employerDescription": "Post jobs, manage applicants and hire with the tools your team needs.",
  "pricing.group.supplier": "For Suppliers & Sellers",
  "pricing.group.supplierDescription": "Sell materials and equipment to projects across the platform.",
  "pricing.addon.boost.title": "Boost a listing",
  "pricing.addon.boost.description": "Push a listing higher for a few days. Pro plans include monthly boosts.",
  "pricing.addon.feature.title": "Get featured",
  "pricing.addon.feature.description": "Priority placement and a featured badge across the marketplace.",
  "pricing.addon.services.title": "Documents & done-for-you",
  "pricing.addon.services.description": "Contract templates and hands-on hiring help, only when you need them.",
  "pricing.addon.other.title": "More add-ons",
  "pricing.addon.other.description": "Other one-time upgrades.",
  "pricing.loading": "Loading plans…",
  "pricing.optionalAddons": "Optional add-ons",
  "pricing.optionalAddonsDescription": "Pick a plan first — these are one-time extras you buy only when you need them.",
  "pricing.protected.title": "Protected transactions",
  "pricing.protected.description": "On services and projects, clients pay a small protection fee when they fund a contract — the worker always receives the full agreed amount. Payment processing is shown separately and is never counted as KontrataPH revenue.",
  "pricing.monthShort": "mo",
  "pricing.yearShort": "yr",
  "pricing.year": "year",
  "pricing.or": "or",
  "pricing.plan.employer_free.name": "Free Employer",
  "pricing.plan.worker_free.name": "Worker Free",
  "pricing.plan.worker_free.tagline": "Everything you need to find work — always free.",
  "pricing.plan.worker_free.f1": "Profile & 5 portfolio items",
  "pricing.plan.worker_free.f2": "Unlimited applications & bids",
  "pricing.plan.worker_free.f3": "Messaging & reviews",
  "pricing.plan.worker_free.f4": "Protected contracts",
  "pricing.plan.worker_free.f5": "Receive the full agreed amount",
  "pricing.plan.worker_pro.name": "Worker Pro",
  "pricing.plan.worker_pro.tagline": "Stand out and win more work.",
  "pricing.plan.worker_pro.f1": "Expanded portfolio & custom link",
  "pricing.plan.worker_pro.f2": "Profile analytics",
  "pricing.plan.worker_pro.f3": "Quote & invoice tools",
  "pricing.plan.worker_pro.f4": "Availability calendar",
  "pricing.plan.worker_pro.f5": "Résumé export",
  "pricing.plan.worker_pro.f6": "2 profile boosts / month included",
  "pricing.plan.worker_pro.f7": "Priority support",
  "pricing.plan.employer_free.tagline": "Post your first role at no cost.",
  "pricing.plan.employer_free.f1": "1 active job",
  "pricing.plan.employer_free.f2": "Up to 15 applications",
  "pricing.plan.employer_free.f3": "5 candidate contacts",
  "pricing.plan.employer_free.f4": "1 admin",
  "pricing.plan.employer_free.f5": "Basic messaging",
  "pricing.plan.employer_growth.name": "Growth",
  "pricing.plan.employer_growth.tagline": "Full ATS and team hiring.",
  "pricing.plan.employer_growth.f1": "10 active jobs",
  "pricing.plan.employer_growth.f2": "300 candidate contacts",
  "pricing.plan.employer_growth.f3": "3 users",
  "pricing.plan.employer_growth.f4": "ATS pipeline & scheduling",
  "pricing.plan.employer_growth.f5": "Matching & analytics",
  "pricing.plan.employer_growth.f6": "2 featured credits",
  "pricing.plan.employer_enterprise.name": "Enterprise",
  "pricing.plan.employer_enterprise.tagline": "High-volume, multi-branch hiring.",
  "pricing.plan.employer_enterprise.f1": "High-volume posting",
  "pricing.plan.employer_enterprise.f2": "Departments & approvals",
  "pricing.plan.employer_enterprise.f3": "Data export & integrations",
  "pricing.plan.employer_enterprise.f4": "Account manager",
  "pricing.plan.employer_enterprise.f5": "Negotiated transaction fees",
  "pricing.plan.supplier_payg.name": "Supplier Pay-as-you-sell",
  "pricing.plan.supplier_payg.tagline": "Sell with no monthly fee.",
  "pricing.plan.supplier_payg.f1": "List products & equipment",
  "pricing.plan.supplier_payg.f2": "5% commission per completed order",
  "pricing.plan.supplier_payg.f3": "Order & delivery tracking",
  "pricing.plan.supplier_pro.name": "Supplier Pro",
  "pricing.plan.supplier_pro.tagline": "Lower commission, more visibility.",
  "pricing.plan.supplier_pro.f1": "Everything in Pay-as-you-sell",
  "pricing.plan.supplier_pro.f2": "3.5% commission",
  "pricing.plan.supplier_pro.f3": "Featured product slots",
  "pricing.plan.supplier_pro.f4": "Listing boosts included",
  "pricing.plan.supplier_pro.f5": "Bulk-quote tools",
  "pricing.plan.supplier_enterprise.name": "Supplier Enterprise",
  "pricing.plan.supplier_enterprise.tagline": "Best rate for high volume.",
  "pricing.plan.supplier_enterprise.f1": "Everything in Pro",
  "pricing.plan.supplier_enterprise.f2": "2.5% commission",
  "pricing.plan.supplier_enterprise.f3": "Sponsored placement credits",
  "pricing.plan.supplier_enterprise.f4": "Priority support",
  "pricing.plan.company_storefront.name": "Enhanced Company Storefront",
  "pricing.plan.company_storefront.tagline": "A richer company page.",
  "pricing.plan.company_storefront.f1": "Enhanced storefront",
  "pricing.plan.company_storefront.f2": "Portfolio & services showcase",
  "pricing.plan.company_storefront.f3": "Lead actions",
  "pricing.plan.boost_3.name": "Listing Boost — 3 days",
  "pricing.plan.boost_7.name": "Listing Boost — 7 days",
  "pricing.plan.boost_30.name": "Listing Boost — 30 days",
  "pricing.plan.post_featured.name": "Urgent / Featured Post",
  "pricing.plan.post_featured.tagline": "Priority placement for 14 days.",
  "pricing.plan.featured_project.name": "Featured Project",
  "pricing.plan.featured_project.tagline": "Category & homepage visibility.",
  "pricing.plan.featured_business.name": "Featured Business Placement",
  "pricing.plan.managed_shortlist.name": "Managed Shortlist",
  "pricing.plan.managed_shortlist.tagline": "We present qualified candidates.",
  "pricing.plan.contract_standard.name": "Standard Contract",
  "pricing.plan.contract_specialized.name": "Specialized Contract",
  "pricing.plan.post_standard.name": "Standard Post",
  "pricing.plan.post_standard.tagline": "30-day listing with wider matching.",
  "pricing.workerFree.name": "Worker Free",
  "pricing.workerFree.tagline": "Everything you need to find work — always free.",
  "pricing.workerFree.f1": "Profile & 5 portfolio items",
  "pricing.workerFree.f2": "Unlimited applications & bids",
  "pricing.workerFree.f3": "Messaging & reviews",
  "pricing.workerFree.f4": "Protected contracts",
  "pricing.workerFree.f5": "Receive the full agreed amount",
  "pricing.workerPro.name": "Worker Pro",
  "pricing.workerPro.tagline": "Stand out and win more work.",
  "pricing.workerPro.f1": "Expanded portfolio & custom link",
  "pricing.workerPro.f2": "Profile analytics",
  "pricing.workerPro.f3": "Quote & invoice tools",
  "pricing.workerPro.f4": "Availability calendar",
  "pricing.workerPro.f5": "Résumé export",
  "pricing.workerPro.f6": "2 profile boosts / month included",
  "pricing.workerPro.f7": "Priority support",
};

export const tl: Record<string, string> = {
  "pricing.workersFree": "Laging libre para sa manggagawa",
  "pricing.title": "Simple at malinaw na pagpepresyo",
  "pricing.comingSoon.title": "Malapit Na",
  "pricing.comingSoon.description": "Malapit nang ilabas ang impormasyon sa pagpepresyo. Samantala, tuklasin ang trabaho, serbisyo, at mga oportunidad sa KontrataPH.",
  "pricing.comingSoon.explore": "Tuklasin ang KontrataPH",
  "pricing.intro": "Libre para sa manggagawa. Magbabayad ka lang para sa mga premium na tool sa negosyo at protektadong transaksyon — makikita ang bawat bayad bago ka magkumpirma.",
  "pricing.group.workers": "Para sa mga Manggagawa at Propesyonal",
  "pricing.group.workersDescription": "Laging libre ang paghahanap ng trabaho. Mag-upgrade lang kung gusto mo ng mas mataas na visibility.",
  "pricing.mostPopular": "Pinakasikat",
  "pricing.free": "Libre",
  "pricing.getStartedFree": "Magsimula nang libre",
  "pricing.choosePlan": "Pumili ng plano",
  "pricing.group.employer": "Para sa mga Employer at Kompanya",
  "pricing.group.employerDescription": "Mag-post ng trabaho, pamahalaan ang mga aplikante, at kumuha ng tao gamit ang mga tool para sa iyong team.",
  "pricing.group.supplier": "Para sa mga Supplier at Nagbebenta",
  "pricing.group.supplierDescription": "Magbenta ng mga materyales at kagamitan sa mga proyekto sa platform.",
  "pricing.addon.boost.title": "Palakasin ang listahan",
  "pricing.addon.boost.description": "Itaas ang puwesto ng listahan nang ilang araw. May buwanang boost ang mga Pro plan.",
  "pricing.addon.feature.title": "Maitampok",
  "pricing.addon.feature.description": "Priyoridad na puwesto at tampok na badge sa buong marketplace.",
  "pricing.addon.services.title": "Mga dokumento at tulong sa pag-hire",
  "pricing.addon.services.description": "Mga template ng kontrata at praktikal na tulong sa pag-hire kapag kailangan mo.",
  "pricing.addon.other.title": "Iba pang add-on",
  "pricing.addon.other.description": "Iba pang minsanang upgrade.",
  "pricing.loading": "Nilo-load ang mga plano…",
  "pricing.optionalAddons": "Mga opsyonal na add-on",
  "pricing.optionalAddonsDescription": "Pumili muna ng plano — minsanang dagdag ito na bibilhin lamang kapag kailangan.",
  "pricing.protected.title": "Mga protektadong transaksyon",
  "pricing.protected.description": "Para sa mga serbisyo at proyekto, nagbabayad ang kliyente ng maliit na bayad sa proteksyon kapag pinondohan ang kontrata — natatanggap pa rin ng manggagawa ang buong napagkasunduang halaga. Hiwalay na ipinapakita ang bayad sa pagproseso ng pagbabayad at hindi ito binibilang na kita ng KontrataPH.",
  "pricing.monthShort": "buwan",
  "pricing.yearShort": "taon",
  "pricing.year": "taon",
  "pricing.or": "o",
  "pricing.plan.worker_free.name": "Libreng Manggagawa",
  "pricing.plan.worker_free.tagline": "Lahat ng kailangan mo para makahanap ng trabaho — laging libre.",
  "pricing.plan.worker_free.f1": "Profile at 5 item sa portfolio",
  "pricing.plan.worker_free.f2": "Walang limitasyong aplikasyon at bid",
  "pricing.plan.worker_free.f3": "Pagmemensahe at mga review",
  "pricing.plan.worker_free.f4": "Mga protektadong kontrata",
  "pricing.plan.worker_free.f5": "Matanggap ang buong napagkasunduang halaga",
  "pricing.plan.worker_pro.name": "Pro na Manggagawa",
  "pricing.plan.worker_pro.tagline": "Mamukod-tangi at manalo ng mas maraming trabaho.",
  "pricing.plan.worker_pro.f1": "Pinalawak na portfolio at sariling link",
  "pricing.plan.worker_pro.f2": "Analytics ng profile",
  "pricing.plan.worker_pro.f3": "Mga tool para sa sipi at invoice",
  "pricing.plan.worker_pro.f4": "Kalendaryo ng availability",
  "pricing.plan.worker_pro.f5": "Pag-export ng résumé",
  "pricing.plan.worker_pro.f6": "Kasama ang 2 pagpapalakas ng profile bawat buwan",
  "pricing.plan.worker_pro.f7": "Priyoridad na suporta",
  "pricing.plan.employer_free.name": "Libreng Employer",
  "pricing.plan.employer_free.tagline": "I-post ang una mong trabaho nang libre.",
  "pricing.plan.employer_free.f1": "1 aktibong trabaho",
  "pricing.plan.employer_free.f2": "Hanggang 15 aplikasyon",
  "pricing.plan.employer_free.f3": "5 kontak ng kandidato",
  "pricing.plan.employer_free.f4": "1 admin",
  "pricing.plan.employer_free.f5": "Pangunahing pagmemensahe",
  "pricing.plan.employer_growth.name": "Paglago",
  "pricing.plan.employer_growth.tagline": "Kumpletong ATS at pag-hire kasama ang team.",
  "pricing.plan.employer_growth.f1": "10 aktibong trabaho",
  "pricing.plan.employer_growth.f2": "300 kontak ng kandidato",
  "pricing.plan.employer_growth.f3": "3 gumagamit",
  "pricing.plan.employer_growth.f4": "Proseso ng ATS at pag-iskedyul",
  "pricing.plan.employer_growth.f5": "Pagtutugma at analytics",
  "pricing.plan.employer_growth.f6": "2 kredito para sa tampok na listahan",
  "pricing.plan.employer_enterprise.name": "Enterprise",
  "pricing.plan.employer_enterprise.tagline": "Malakihang pag-hire sa maraming sangay.",
  "pricing.plan.employer_enterprise.f1": "Malakihang pag-post",
  "pricing.plan.employer_enterprise.f2": "Mga departamento at pag-apruba",
  "pricing.plan.employer_enterprise.f3": "Pag-export ng datos at integrasyon",
  "pricing.plan.employer_enterprise.f4": "Tagapamahala ng account",
  "pricing.plan.employer_enterprise.f5": "Napagkasunduang bayad sa transaksyon",
  "pricing.plan.supplier_payg.name": "Supplier na bayad kada benta",
  "pricing.plan.supplier_payg.tagline": "Magbenta nang walang buwanang bayad.",
  "pricing.plan.supplier_payg.f1": "Maglista ng mga produkto at kagamitan",
  "pricing.plan.supplier_payg.f2": "5% komisyon sa bawat nakumpletong order",
  "pricing.plan.supplier_payg.f3": "Pagsubaybay sa order at paghahatid",
  "pricing.plan.supplier_pro.name": "Pro na Supplier",
  "pricing.plan.supplier_pro.tagline": "Mas mababang komisyon, mas mataas na visibility.",
  "pricing.plan.supplier_pro.f1": "Lahat ng kasama sa bayad kada benta",
  "pricing.plan.supplier_pro.f2": "3.5% komisyon",
  "pricing.plan.supplier_pro.f3": "Tampok na puwesto para sa produkto",
  "pricing.plan.supplier_pro.f4": "Kasamang pagpapalakas ng listahan",
  "pricing.plan.supplier_pro.f5": "Mga tool para sa maramihang sipi",
  "pricing.plan.supplier_enterprise.name": "Enterprise na Supplier",
  "pricing.plan.supplier_enterprise.tagline": "Pinakamainam na singil para sa malaking benta.",
  "pricing.plan.supplier_enterprise.f1": "Lahat ng kasama sa Pro",
  "pricing.plan.supplier_enterprise.f2": "2.5% komisyon",
  "pricing.plan.supplier_enterprise.f3": "Mga kredito para sa sponsored na puwesto",
  "pricing.plan.supplier_enterprise.f4": "Priyoridad na suporta",
  "pricing.plan.company_storefront.name": "Pinahusay na Pahina ng Kompanya",
  "pricing.plan.company_storefront.tagline": "Mas detalyadong pahina ng kompanya.",
  "pricing.plan.company_storefront.f1": "Pinahusay na pahina ng kompanya",
  "pricing.plan.company_storefront.f2": "Pagpapakita ng portfolio at serbisyo",
  "pricing.plan.company_storefront.f3": "Mga paraan para makipag-ugnayan",
  "pricing.plan.boost_3.name": "Pagpapalakas ng Listahan — 3 araw",
  "pricing.plan.boost_7.name": "Pagpapalakas ng Listahan — 7 araw",
  "pricing.plan.boost_30.name": "Pagpapalakas ng Listahan — 30 araw",
  "pricing.plan.post_featured.name": "Agarang / Tampok na Post",
  "pricing.plan.post_featured.tagline": "Priyoridad na puwesto sa loob ng 14 na araw.",
  "pricing.plan.featured_project.name": "Tampok na Proyekto",
  "pricing.plan.featured_project.tagline": "Mas nakikita sa kategorya at homepage.",
  "pricing.plan.featured_business.name": "Tampok na Puwesto para sa Negosyo",
  "pricing.plan.managed_shortlist.name": "Pinamahalaang Shortlist",
  "pricing.plan.managed_shortlist.tagline": "Maghahain kami ng mga kwalipikadong kandidato.",
  "pricing.plan.contract_standard.name": "Karaniwang Kontrata",
  "pricing.plan.contract_specialized.name": "Espesyalisadong Kontrata",
  "pricing.plan.post_standard.name": "Karaniwang Post",
  "pricing.plan.post_standard.tagline": "30 araw na listahan na may mas malawak na pagtutugma.",
  "pricing.workerFree.name": "Libreng Manggagawa",
  "pricing.workerFree.tagline": "Lahat ng kailangan mo para makahanap ng trabaho — laging libre.",
  "pricing.workerFree.f1": "Profile at 5 item sa portfolio",
  "pricing.workerFree.f2": "Walang limitasyong aplikasyon at bid",
  "pricing.workerFree.f3": "Pagmemensahe at mga review",
  "pricing.workerFree.f4": "Mga protektadong kontrata",
  "pricing.workerFree.f5": "Matanggap ang buong napagkasunduang halaga",
  "pricing.workerPro.name": "Pro na Manggagawa",
  "pricing.workerPro.tagline": "Mamukod-tangi at manalo ng mas maraming trabaho.",
  "pricing.workerPro.f1": "Pinalawak na portfolio at sariling link",
  "pricing.workerPro.f2": "Analytics ng profile",
  "pricing.workerPro.f3": "Mga tool para sa sipi at invoice",
  "pricing.workerPro.f4": "Kalendaryo ng availability",
  "pricing.workerPro.f5": "Pag-export ng résumé",
  "pricing.workerPro.f6": "Kasama ang 2 pagpapalakas ng profile bawat buwan",
  "pricing.workerPro.f7": "Priyoridad na suporta",
};
